import type { ProgramConfig, SSOConfig } from '../types/schema';

type SSOConfigLike = Partial<SSOConfig> | null | undefined;

const REQUIRED_SSO_FIELDS: Array<keyof SSOConfig> = [
  'provider',
  'issuer',
  'authorizeUrl',
  'tokenUrl',
  'clientId',
  'scopes',
];

function hasNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

export function getMissingSSOFields(sso: SSOConfigLike): string[] {
  if (!sso) return [...REQUIRED_SSO_FIELDS];

  return REQUIRED_SSO_FIELDS.filter((field) => {
    if (field === 'scopes') {
      return !Array.isArray(sso.scopes)
        || sso.scopes.length === 0
        || sso.scopes.some((scope) => !hasNonEmptyString(scope));
    }

    return !hasNonEmptyString(sso[field]);
  });
}

export function hasUsableSSOConfig(sso: SSOConfigLike): sso is SSOConfig {
  return getMissingSSOFields(sso).length === 0;
}

export function hasUsableAuthConfig(config: Pick<ProgramConfig, 'magicLinksEnabled' | 'sso'>): boolean {
  return config.magicLinksEnabled === true || hasUsableSSOConfig(config.sso);
}

export function getAuthConfigurationError(config: Pick<ProgramConfig, 'magicLinksEnabled' | 'sso'>): string | null {
  if (hasUsableAuthConfig(config)) return null;

  if (config.sso) {
    return 'This portal has an incomplete sign-in configuration. Please contact support for help.';
  }

  return 'This portal does not have a sign-in method configured. Please contact support for help.';
}